import { categoryList } from "@/mocks/melon";

const QUICK = [
  { label: "今日头条", href: "#top" },
  { label: "全网热榜", href: "#hot" },
  { label: "突发大事", href: "#breaking" },
  { label: "大事件复盘", href: "#review" },
  { label: "吃瓜词典", href: "#dict" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">瓜田日报</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              全网热门事件资讯站，把碎片热点按热榜、突发与复盘三层整理，帮你每天用更少时间，看懂更多重点。
            </p>
            <div className="mt-5 flex items-center gap-2 text-foreground-600">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-douban-fill"].map((ic) => (
                <span
                  key={ic}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-base transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className={ic} aria-hidden="true" />
                </span>
              ))}
            </div>
          </div>

          <nav className="lg:col-span-3" aria-label="页脚导航">
            <h3 className="text-sm font-bold text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {QUICK.map((q) => (
                <li key={q.href}>
                  <a href={q.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-4" aria-label="栏目链接">
            <h3 className="text-sm font-bold text-foreground-900">内容栏目</h3>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2.5">
              {categoryList.map((c) => (
                <li key={c.name}>
                  <a href="#category" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
      <div className="border-t border-background-300">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-center text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 瓜田日报. 所有热点内容均为编辑部公开趋势整理，仅供参考。</p>
          <p>用心吃瓜 · 理性围观 · 每天 3 分钟看懂全网</p>
        </div>
      </div>
    </footer>
  );
}